
  import cms from '~/mixins/common/cms'
  export default {
    name: 'CommonsVerticalFloatingIcons',
    mixins: [cms],
    props: {
      items: {
        type: Array,
        required: true,
        default: () => {}
      },
      componentCode: {
        type: String,
        required: true,
        default: ''
      }
    },
    methods: {
      openNewWindow(link) {
        // Track contact pixel event
        this.trackPixelEvent(this.PIXEL_EVENTS.contact)

        // Open Contact URL in new window
        setTimeout(() => {
          window.open(
            !link.toLowerCase().startsWith('http') ? 'http://' + link : link,
            '_blank',
            'width=550,height=600'
          )
        }, 150)
      }
    }
  }
